export default {
  namespaced: true,
  state: {
    byId: {
      1: { name: '細線' },
      2: { name: '細線　白抜き' },
      3: { name: '太線' },
      4: { name: '太線　白抜き' },
      5: { name: 'コーナー' },
      6: { name: 'コーナー　白抜き' },
      7: { name: 'アーチ' },
      8: { name: 'アーチ　白抜き' },
      9: { name: '丸' },
      10: { name: '三角' },
      11: { name: '正方形' },
      12: { name: 'トイレ' },
      13: { name: 'レジ' },
      14: { name: '入口' },
      15: { name: '階段' },
      16: { name: 'エレベーター' },
    },
  },
  getters: {
    all(state) {
      return Object.keys(state.byId)
        .sort()
        .map(id => state.byId[id])
    },
  },
}
